import React, { FC, useState } from 'react';
import {
  Area,
  AreaChart,
  CartesianGrid,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from 'recharts';
import { InputCheckbox } from '@shared/uikit/input-checkbox';

interface IMultiLinesChartProps {
  data: {
    name: string;
    referralHashRates?: number;
    hashRates?: number;
  }[];
}

const AccountLinesChart: FC<IMultiLinesChartProps> = ({ data }) => {
  const [mining, setMining] = useState<boolean>(true);
  const [agent, setAgent] = useState<boolean>(true);

  return (
    <>
      <ResponsiveContainer width="100%" height={300}>
        <AreaChart data={data} margin={{ top: 10, right: 30, left: 0, bottom: 0 }}>
          <defs>
            {mining ? (
              <linearGradient id="hashRates" x1="0" y1="0" x2="0" y2="1">
                <stop offset="5%" stopColor="#2E9691" stopOpacity={0.8} />
                <stop offset="95%" stopColor="#2E9691" stopOpacity={0} />
              </linearGradient>
            ) : null}

            {agent ? (
              <linearGradient id="referralHashRates" x1="0" y1="0" x2="0" y2="1">
                <stop offset="5%" stopColor="#12BC37" stopOpacity={0.8} />
                <stop offset="95%" stopColor="#12BC37" stopOpacity={0} />
              </linearGradient>
            ) : null}
          </defs>
          <XAxis dataKey="name" interval={0} tickLine={false} />
          <YAxis />
          {152 > data.length ? <CartesianGrid opacity={0.1} color="#5E5E5E33" /> : null}
          <Tooltip
            contentStyle={{
              backgroundColor: '#211F24',
              borderRadius: '8px',
              border: 'none',
            }}
          />
          <Area
            type="natural"
            name={'Дата'}
            dataKey="Дата"
            stroke="white"
            stackId={213}
            fillOpacity={1}
          />

          {mining ? (
            <Area
              type="monotone"
              dataKey="hashRates"
              name={'Майнинг аккаунты'}
              unit={' Ph'}
              stroke="#2E9691"
              fillOpacity={1}
              fill="url(#hashRates)"
            />
          ) : null}

          {agent ? (
            <Area
              type="monotone"
              dataKey="referralHashRates"
              name={'Агентские аккаунты'}
              stroke="#12BC37"
              unit={' Ph'}
              fillOpacity={1}
              fill="url(#referralHashRates)"
            />
          ) : null}
        </AreaChart>
      </ResponsiveContainer>
      <div className="flex flex-wrap gap-x-[20px] gap-y-[5px] px-[55px] pt-[15px]">
        <InputCheckbox
          value={mining}
          onChange={value => {
            setMining(value);
          }}
          label="Майнинг аккаунты"
        />
        <InputCheckbox
          value={agent}
          onChange={value => {
            setAgent(value);
          }}
          label="Агентские аккаунты"
        />
      </div>
    </>
  );
};

export default AccountLinesChart;
